import { Badge, BadgeProps, FlexRow } from '@make-software/cspr-design';
import React from 'react';
import { useTheme } from 'styled-components';
import { Tooltip } from '@block-explorer/ui';
import { useTranslation } from 'react-i18next';

export const WasmProxyBadge = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Tooltip
      tooltipContent={t(
        'This WASM transaction ran the code from the identified smart contract.'
      )}
    >
      <FlexRow gap={3} align={'center'}>
        <Badge
          lineHeight={'xxs'}
          label={'WASM'}
          variation={theme.styleguideColors.contentLightBlue}
        />
      </FlexRow>
    </Tooltip>
  );
};
